// extracted by mini-css-extract-plugin
module.exports = {"list":"style-module--list--24PAn","image":"style-module--image--3X5bB"};